var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceSavedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 20 20",
    width: 30,
    height: 30,
    stroke: "#EFA18F",
    strokeWidth: 1.5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.492.7a6.08 6.08 0 00-2.193.439l-.033.014-.033.017c-.461.235-.88.528-1.254.876C6.971.308 3.773.182 1.585 2.154l-.022.02-.02.021C-.376 4.2-.331 7.287.819 9.726l.01.019.01.02c1.355 2.509 3.885 4.641 6.19 6.393l.006.005.005.004.698.555c.294.221.627.464 1.114.557l.109.021.11-.009c.511-.044.711-.233 1.047-.444a14.67 14.67 0 001.089-.773l2.043-1.72.024-.021.003-.003c1.08-.921 2.149-1.984 3.056-3.233l.001-.001c1.443-1.943 2.141-4.552 1.309-7.123l-.015-.046-.02-.043C16.674 1.864 14.665.677 12.492.7z"
  })));
}
export default SvgSpaceSavedIcon;